import { ChartElement } from "./ChartElement";
import { Offer } from "../entity/Offer";

export class ChartCallout {
   isOffer: boolean = false;
   offerTitle: string|null = null;
   offerId: number|null = null;
   title: string;
   color: string;
   details: string|null;
   counterTemplate: string|null;
   counter: number|null;
   relatedChartElement: ChartElement|null;
   relatedSlidePos: number|null = null;
}


